import { combineReducers } from 'redux';

// Front
import Auth from './auth/reducer';

export default combineReducers({
  Auth,
})
